import React from 'react';
import './Navbar.css'
import { AiFillHome, AiFillProject, AiFillGithub } from 'react-icons/ai';
import { FaBlog } from 'react-icons/fa';
import { RiContactsFill } from 'react-icons/ri';
import { MdPermContactCalendar } from 'react-icons/md';
import { CgTikcode } from 'react-icons/cg';

const Navbar = () => {
    return (
        <>
            {/* ----------------- Mobile Navbar! -------------- */}
            <nav className="mobileNav">
                <a href="/home" className="navLink">
                    <AiFillHome className="navIcon" />
                    <span className="navText">Home</span>
                </a>
                <a href="/about" className="navLink">
                    <MdPermContactCalendar className="navIcon" />
                    <span className="navText">About</span>
                </a>
                <a href="/protfolio" className="navLink">
                    <AiFillProject className="navIcon" />
                    <span className="navText">Protfolio</span>
                </a>
                <a href="/contact" className="navLink">
                    <RiContactsFill className="navIcon" />
                    <span className="navText">Contact</span>
                </a>
                <a href="/blog" className="navLink">
                    <FaBlog className="navIcon" />
                    <span className="navText">Blog</span>
                </a>
            </nav>

            {/* ----------------- Desktop Navbar ---------------- */}
            <nav className="desktopNav">
                <a href="/">
                    <div className="navLogo">
                        <CgTikcode className="logoSize" />
                        <h3 className="logoFont">Sajjad.Dev</h3>
                    </div>
                </a>
                <div className="navMenu">
                    <a href="/home" className="navLink">
                        <AiFillHome className="navIcon" />
                        <span className="navText">Home</span>
                    </a>
                    <a href="/about" className="navLink">
                        <MdPermContactCalendar className="navIcon" />
                        <span className="navText">About</span>
                    </a>
                    <a href="/protfolio" className="navLink">
                        <AiFillProject className="navIcon" />
                        <span className="navText">Protfolio</span>
                    </a>
                    <a href="/contact" className="navLink">
                        <RiContactsFill className="navIcon" />
                        <span className="navText">Contact</span>
                    </a>
                    <a href="/blog" className="navLink">
                        <FaBlog className="navIcon" />
                        <span className="navText">Blog</span>
                    </a>
                </div>
                <div className="navSocialIcon">
                    <a title="GitHub" target="_blank" title="Github" href="https://github.com/sajjadsadiqofficial">
                        <AiFillGithub className="icon" f />
                    </a>
                </div>
            </nav>



        </>
    );
};

export default Navbar;